import { generateSubnetApiLogsUrl } from 'pages/Subnets/panels/LogsPanel/useApiLog'
import { useState } from 'react'
import { useValidatorPendingAccounts } from 'services/admin/useAdminService'

interface FilterProps {
	limit: number
	page: number
	active: boolean
}

const getTotalPages = (limit: number, total_count: number) =>
	total_count > limit ? Math.ceil(total_count / limit) : null

const default_filter: FilterProps = {
	page: 1,
	limit: 20,
	active: true,
}

export const useAccounts = ({ active }: { active: boolean }) => {
	const [filter, setFilter] = useState<FilterProps>({ ...default_filter, active })

	const url = generateSubnetApiLogsUrl(filter)

	const { data: accounts, loading: accounts_loading } = useValidatorPendingAccounts(url)

	const { items, total_count } = accounts

	const total_pages = getTotalPages(filter.limit, total_count)

	const setPage = (pageNumber: number) => {
		setFilter({ ...filter, page: pageNumber })
	}

	return {
		accounts: items,
		accounts_loading,
		total_pages,
		setPage,
		filter,
	}
}
